import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizCard, WizModal } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool
import moment from 'moment'

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/callCar') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('callCar', record)
        } else {
            record = Session.get('callCar') || {}
        }
    }
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/callAccessories') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('callAccessories', record)
        } else {
            record = Session.get('callAccessories') || {}
        }
    }
    return record
}

class CallCar extends WizContainer {

    componentName = 'CallCar'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/callCar',
            payload: {
                key: 'callCar@' + processContentId,
                apiParams: {
                    processId: processContentId
                }
            }
        })
    }

    _onBtn = (type, id) => {
        const { processContentId, moduleType } = this.state.record
        let path
        switch (type) {
            case 'look':
                path = `/integrationCounseling/manager/antecedentIntervention/${moduleType === 0 ? 'callCar' : 'callAccessories'}/look`
                break
            case 'audit':
                path = `/integrationCounseling/manager/antecedentIntervention/${moduleType === 0 ? 'callCar' : 'callAccessories'}/examine`
                break
        }
        this.jumpPage('push', path, { processContentId, recordId: id, moduleType })
    }

    _onConfirm = () => {
        const { processContentId } = this.state.record
        WizModal.confirm({
            title: '注意',
            content: '是否确认进行达标确认操作？',
            onOk: () => {
                this.doAction({
                    path: 'counselingProcess/confirmCallCar',
                    payload: {
                        key: 'confirmCallCar@' + processContentId,
                        apiParams: {
                            processId: processContentId
                        }
                    }
                })
            },
            onCancel() {
            }
        })
    }

    propsAndStateOnChange = {
        confirm: this._confirmOnChange.bind(this)
    }

    _confirmOnChange(nextProps, nextState) {
        if (nextProps.confirm.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.confirm.msg)
        }
    }

    render() {
        let { record } = this.state
        let { processContentState, moduleType } = record
        let { list, counselingProcessLoading } = this.props
        let data = list.data && list.data.length ? list.data[0] || {} : {}
        let columns = [{
            title: '执行内容',
            name: 'processName',
            dataIndex: 'processName',
        }, {
            title: `首次${moduleType === 0 ? '拷车' : '拷配件'}日期`,
            name: 'submitTime',
            dataIndex: 'submitTime',
            render: (v) => v ? moment(v).format('YYYY-MM-DD') : ''
        }, {
            title: '审核结果',
            name: 'state',
            dataIndex: 'state',
            render: (v) => {
                switch (v) {
                    case 0:
                        return '不合格'
                    case 1:
                        return '合格'
                    default:
                        return ''
                }
            }
        }, {
            title: '审核意见',
            name: 'remark',
            dataIndex: 'remark'
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 220,
            render: (v, r, i) => {
                let { id, submitTime, remark } = r
                let disabled = !submitTime || processContentState !== 0
                return (
                    <WizButton.Group>
                        <WizButton type='link' disabled={!submitTime} onClick={() => this._onBtn('look', id)}>
                            {'查看'}
                        </WizButton>
                        <WizButton type='link' disabled={disabled} onClick={() => this._onBtn('audit', id)}>
                            {remark ? '复审' : '审核'}
                        </WizButton>
                    </WizButton.Group>
                )
            }
        }]

        let tableProps = {
            columns,
            dataSource: list.data || [],
            pagination: false,
            bordered: true
        }

        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title={`首次${moduleType === 0 ? '拷车' : '拷配件'}`}>
                    <WizButton
                        type='primary'
                        style={{ marginBottom: 15, width: 90 }}
                        disabled={processContentState !== 0 || data.state !== 1}
                        onClick={() => this._onConfirm()}>
                        {'达标确认'}
                    </WizButton>
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'callCar@' + processContentId)
    const confirm = modelUtils.getModelEntity(counselingProcess, 'confirmCallCar@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        confirm,
        ...loading
    }
}

export default connect(mapStateToProps)(CallCar)


